// const mainHome = () => import(/* webpackChunkName: "core-pad" */'../components/layouts/pad/layout-home')
// const mainModule = () => import(/* webpackChunkName: "core-pad" */'../components/layouts/pad/layout-module')
// const moreModule = () => import(/* webpackChunkName: "core-pad" */'../components/layouts/pad/more')

import mainHome from '../components/layouts/pad/layout-home'
import mainModule from '../components/layouts/pad/layout-module'


function setLayout(app, routes) {
  // 2021/3/5 移出手机布局与 public/project.js 之间的联系 目的是为了防止开发人员迁移public目录时误删多删时页面出不来  
  // if (!app.config.pad || !app.config.pad.homes) throw new Error("pad.homes not exists")



  // let homes = app.menus.map(p => p.name);
  // console.log('app>>>>>>>>>',app);
  // console.log('routes>>>>>>>>',routes)

  routes.forEach((route, index) => {

    if (index == 0) {
      route.component = mainHome;

      if (!app.menus.some((p) => p.name === route.redirect.name))
        route.redirect = "/core-phoneModulesNav0"
      return true;
    } else {
      let path = route.path;
      let name = route.name || `gen${index}`;
      let component = route.component;
      route.path = `/main-${index}`;
      route.component = mainModule;
      route.redirect = { name: name };
      route.children = [{
        path,
        name,
        component
      }]
    }
    // route = {
    //     name: route.name || `gen${index}` + "-parent",
    //     // text: route.text,
    //     path: `/main`,
    //     component: mainModule,
    //     // redirect: { name: route.name },
    //     // icon: route.icon,
    //     children: [route]
    // }
    routes[index] = route;
  });




  // let homes = app.config.pad.homes || []
  // if (homes.length === 0) throw new Error("0 homes,please set the the home pages first")

  // const modules = []
  // resolveRunableModules(routes, modules, { isTop: true })

  // //选出前4个
  // let isAllHome = false;
  // if (modules.length <= 4) {
  //     isAllHome = true
  // }
  // else {
  //     homes = homes.filter(t => {
  //         return modules.filter(tt => tt.name === t).length > 0
  //     }).slice(0, 3);
  //     if (homes.length === 0) throw new Error("应不少于2个主页")
  // }

  // const homeModules = []
  // const runableModules = []

  // routes.length = 0

  // modules.forEach(module => {
  //     if (isAllHome || homes.indexOf(module.name) !== -1) {
  //         module.meta.isHome = true
  //         homeModules.push(module)
  //     }
  //     else {
  //         module.meta.isHome = false
  //         runableModules.push(module)
  //     }
  //     module = {
  //         name: module.name + "-parent",
  //         text: module.text,
  //         path: '/main',
  //         component: module.meta.isHome ? mainHome : mainModule,
  //         redirect: { name: module.name },
  //         icon: module.icon,
  //         children: [module]
  //     }
  //     routes.push(module)
  // })

  // //按顺序排列
  // homeModules.sort((a, b) => {
  //     let aIndex = homes.indexOf(a.name)
  //     let bIndex = homes.indexOf(b.name)
  //     return aIndex - bIndex
  // })
  // if (runableModules.length > 0) {
  //     let more = {
  //         name: "$more",
  //         path: "/pad/more",
  //         component: moreModule,
  //         icon: "ivu-icon ivu-icon-ios-compass-outline",
  //         text: "更多",
  //         meta: {
  //             text: "更多",
  //             isHome: true
  //         }
  //     }
  //     let module = {
  //         name: "more-pad",
  //         text: more.text,
  //         path: '/pad/main',
  //         component: mainHome,
  //         redirect: { name: more.name },
  //         icon: more.icon,
  //         children: [more]
  //     }
  //     homeModules.push(more)
  //     routes.push(module)
  // }

  // //刷新回主页
  // const curHash = location.hash.replace(/^#/, "")
  // if (homeModules.length > 0) {
  //     let tt = homeModules.filter(t => t.path === curHash);
  //     if (tt.length === 0) location.hash = homeModules[0].path
  // }

  // app.homeModules = homeModules
  // app.runableModules = runableModules
}
function resolveRunableModules(routes, modules, context) {
  routes.forEach(route => {
    if (route.children && route.children.length > 0) {
      let ctx = {};    //保留最顶层分组信息
      if (context.isTop === true) {
        ctx.isTop = false
        ctx.icon = route.icon
        ctx.text = route.text
      }
      else {
        ctx = context
      }
      resolveRunableModules(route.children, modules, ctx)
    }
    else {
      route.groupIcon = context.icon
      route.groupText = context.text
      modules.push(route)
    }
  })
}

export default {
  name: "pad",
  login: null,
  maxWidth: 1024,
  minWidth: 300,
  text: "手机布局",
  layout: setLayout
}